import React from 'react';

import Chip from '@mui/material/Chip';

import { ProjectStatus } from 'stores/ProjectStoreAdapter';

const ProjectStatusColor: Record<ProjectStatus, 'warning' | 'success' | 'default'> = {
  PREPARING: 'warning',
  ACTIVE: 'success',
  CLOSED: 'default',
};

type Props = {
  status: ProjectStatus;
  size?: 'small' | 'medium';
  onClick?: () => void;
};

/**
 * プロジェクトステータス専用 Chip コンポーネント。
 * ステータスに応じたラベルと色を ProjectStatus 定数から取得して表示する。
 */
const ProjectStatusChip: React.FC<Props> = ({ status, size = 'small', onClick }) => {
  return (
    <Chip
      label={ProjectStatus[status]}
      size={size}
      color={ProjectStatusColor[status]}
      onClick={onClick}
      sx={{
        cursor: onClick ? 'pointer' : 'default',
        ...(size === 'small' && { height: 20, fontSize: '0.7rem' }),
      }}
    />
  );
};

export default ProjectStatusChip;
